import { Stack } from "@mui/material";

import { TakeoverFilterBar } from "./components/filter/TakeoverFilterBar";
import { TakeoverHeader } from "./components/header/TakeoverHeader";
import { TakeoverHistoryPanel } from "./components/history-panel/TakeoverHistoryPanel";
import { TakeOverDialog } from "./components/take-over-dialog/TakeOverDialog";
import { TakeoverBoard } from "./components/takeover-board/TakeoverBoard";
import { useTakeover } from "./hooks/useTakeover";

export function Takeover() {
  const {
    view,
    setView,
    toTakeOverCount,
    counselorId,
    setCounselorId,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    appointments,
    isLoading,
    isBusy,
    selectionModel,
    setSelectionModel,
    markableCount,
    removableCount,
    bulkMark,
    bulkRemove,
    paginationResetKey,
    mark,
    unmark,
    takeOverTarget,
    setTakeOverTarget,
    confirmTakeOver,
    isTakeOverPending,
    requestReverse,
    isHistoryOpen,
    openHistory,
    closeHistory,
  } = useTakeover();

  return (
    <Stack spacing={2} sx={{ height: "100%" }} pb={3}>
      <TakeoverHeader
        view={view}
        markableCount={markableCount}
        removableCount={removableCount}
        isBusy={isBusy}
        onMark={bulkMark}
        onRemove={bulkRemove}
        onHistoryClick={openHistory}
      />
      <TakeoverFilterBar
        view={view}
        toTakeOverCount={toTakeOverCount}
        onViewChange={setView}
        counselorId={counselorId}
        onCounselorChange={setCounselorId}
        dateFrom={dateFrom}
        dateTo={dateTo}
        onDateFromChange={setDateFrom}
        onDateToChange={setDateTo}
      />
      <Stack sx={{ overflow: "auto", flex: 1, minHeight: 0 }}>
        <TakeoverBoard
          appointments={appointments}
          view={view}
          isBusy={isBusy}
          isLoading={isLoading}
          selectionModel={selectionModel}
          onSelectionModelChange={setSelectionModel}
          paginationResetKey={paginationResetKey}
          onTakeOver={setTakeOverTarget}
          onReverse={requestReverse}
          onMark={mark}
          onUnmark={unmark}
        />
      </Stack>

      {takeOverTarget && (
        <TakeOverDialog
          appointment={takeOverTarget}
          isSubmitting={isTakeOverPending}
          onClose={() => setTakeOverTarget(null)}
          onConfirm={confirmTakeOver}
        />
      )}

      {isHistoryOpen && <TakeoverHistoryPanel onClose={closeHistory} />}
    </Stack>
  );
}
